export default __webpack_public_path__ + "static/media/compiegne4.9a92a3bd.jpg";